<template>
  <div :id="'f_field' + pFieldValue.fieldFieldTemplateId"
       :class="['form-group',  'bs3-row-reset', {'has-error': hasFieldErrors(errorKey)}]">
    <input type="hidden" :name="fieldInputNamePrefix + '.id'" :value="pFieldValue.id"/>
    <input type="hidden" :name="fieldInputNamePrefix + '.fieldId'" :value="pFieldValue.fieldId"/>
    <input type="hidden" :name="fieldInputNamePrefix + '.fieldFieldTemplateId'" :value="pFieldValue.fieldFieldTemplateId"/>
    <!-- ERRORS -->
    <div v-if="hasFieldErrors(errorKey)">
      <span v-for="error in getFieldErrors(errorKey)" class="field-error help-block" :key="error">{{ error }}</span>
    </div>
    <!-- LABEL -->
    <label v-else :for="fieldInputId">
      <span v-if="pFieldValue.required" class="required bs3-margin-right3">*</span>
      <span>{{ i18nRefName(pFieldValue, pLanguage) }}:</span>
      <!-- DESCRIPTION ICON -->
      <i v-if="descriptionIconVisible" class="field-description fa fa-circle-question" aria-hidden="true" data-toggle="tooltip"
         data-container="body" data-placement="top" :title="pFieldValue.description"></i>
    </label>
    <!-- DESCRIPTION HELP -->
    <p v-if="descriptionHelpVisible" class="field-description help-block">{{ pFieldValue.description }}</p>
    <!-- TEXT FIELD -->
    <field-value-text-form
        v-if="textField"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-urls="pUrls"
        :p-error-list="pErrorList"
        :p-src="pSrc"
        :p-src-id="pSrcId"
        :p-field-value="pFieldValue"
        :p-field-value-input-id="fieldInputId"
        :p-field-value-input-name-prefix="fieldInputNamePrefix">
    </field-value-text-form>
    <!-- LIST FIELD -->
    <field-value-list-form
        v-if="listField"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-urls="pUrls"
        :p-error-list="pErrorList"
        :p-src="pSrc"
        :p-src-id="pSrcId"
        :p-field-value="pFieldValue"
        :p-field-value-input-id="fieldInputId"
        :p-field-value-input-name-prefix="fieldInputNamePrefix">
    </field-value-list-form>
    <!-- DATE FIELD -->
    <field-value-date-form
        v-if="dateField"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-urls="pUrls"
        :p-error-list="pErrorList"
        :p-src="pSrc"
        :p-src-id="pSrcId"
        :p-field-value="pFieldValue"
        :p-field-value-input-id="fieldInputId"
        :p-field-value-input-name-prefix="fieldInputNamePrefix">
    </field-value-date-form>
    <!-- NUMBER FIELD -->
    <field-value-number-form
        v-if="numberField"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-urls="pUrls"
        :p-error-list="pErrorList"
        :p-src="pSrc"
        :p-src-id="pSrcId"
        :p-field-value="pFieldValue"
        :p-field-value-input-id="fieldInputId"
        :p-field-value-input-name-prefix="fieldInputNamePrefix">
    </field-value-number-form>
    <!-- MATH FIELD -->
    <field-value-math-form
        v-if="mathField"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-urls="pUrls"
        :p-error-list="pErrorList"
        :p-src="pSrc"
        :p-src-id="pSrcId"
        :p-field-value="pFieldValue"
        :p-field-value-input-id="fieldInputId"
        :p-field-value-input-name-prefix="fieldInputNamePrefix">
    </field-value-math-form>
  </div>
</template>

<script>
import stringHelpers from '@/helpers/string-helpers'
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FieldValueTextForm from "@/components/common/field/form/FieldValueTextForm";
import FieldValueNumberForm from "@/components/common/field/form/FieldValueNumberForm";
import FieldValueMathForm from "@/components/common/field/form/FieldValueMathForm";
import FieldValueDateForm from "@/components/common/field/form/FieldValueDateForm";
import FieldValueListForm from "@/components/common/field/form/FieldValueListForm";

export default {
  name: "FieldValueForm",
  components: {FieldValueTextForm, FieldValueNumberForm, FieldValueMathForm, FieldValueDateForm, FieldValueListForm},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pIndex: {
      type: Number,
      default: function () {
        return 0;
      }
    },
     pFieldInputId: {
       type: String,
        default: function() {
           return 'saveXXX_dataForm_fieldValueRefs_' + this.pIndex + '_value';
        }
     },
    pFieldInputNamePrefix: {
      type: String,
       default: function() {
          return 'dataForm.fieldValueRefs[' + this.pIndex + ']';
       }
    },
    pFieldValue: {
      type: Object,
      required: true
    }
  },
  computed: {
    fieldInputId: function () {
      return this.pFieldInputId;
    },
    fieldInputNamePrefix: function () {
      return this.pFieldInputNamePrefix;
    },
    errorKey: function () {
      return this.fieldInputNamePrefix + '.value';
    },
    descriptionIconVisible: function () {
      return this.pFieldValue.descriptionDisplayOption === 0
             && !stringHelpers.isEmptyOrNull(this.pFieldValue.description)
    },
    descriptionHelpVisible: function () {
      return this.pFieldValue.descriptionDisplayOption === 1
             && !stringHelpers.isEmptyOrNull(this.pFieldValue.description)
    },
    textField: function () {
      return this.pFieldValue.type === 1;
    },
    listField: function () {
      return this.pFieldValue.type === 2;
    },
    dateField: function () {
      return this.pFieldValue.type === 3;
    },
    numberField: function () {
      return this.pFieldValue.type === 4;
    },
    mathField: function () {
      return this.pFieldValue.type === 5;
    }
  }
}
</script>

<style scoped>

</style>